import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { State } from "@/store/state";
import { uniAbcModule } from "@/store/uniabc";
import { gitLabModule } from "@/store/gitlab";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";
import { appStateModule } from "@/store/appState";

Vue.use(Vuex);

const gitLabPersistState = createPersistedState({
  paths: ["gitLab"],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rehydrated: (loadedStore: any) => {
    axios.defaults.headers["PRIVATE-TOKEN"] =
      loadedStore.getters.getAccessToken;
  }
});

// const uniAbcPersistState = createPersistedState({
//     paths: ["uniAbc"],
// });

const storeOptions: StoreOptions<State> = {
  modules: {
    uniAbc: uniAbcModule,
    gitLab: gitLabModule,
    appState: appStateModule
  },
  plugins: [
    // uniAbcPersistState,
    gitLabPersistState
  ]
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
